import { $api, getAuthHeader } from '@/services/api/client'
import { useToast } from '../use-toast'

export function usePreferenceData() {
  const { toast } = useToast()

  const { data, isLoading, refetch } = $api.useQuery('get', '/preference', {
    headers: getAuthHeader(),
    onError: () => {
      toast({
        title: 'การดึงการตั้งค่าของคุณไม่สำเร็จ',
        description: 'เกิดข้อผิดพลาดระหว่างการดึงข้อมูลการค้งค่า',
        variant: 'destructive',
      })
    },
  })

  return {
    preference: data?.data,
    isLoading,
    refetch,
  }
}

export function useUpdatePreference() {
  const { toast } = useToast()

  const {
    mutate: updatePreference,
    error: mutationError,
    isPending: isMutationPending,
  } = $api.useMutation('put', '/preference', {
    onSuccess: () => {
      toast({
        title: 'บันทึกการตั้งค่าเรียบร้อย',
        description: 'การตั้งค่าของคุณได้รับการบันทึกแล้ว',
      })
    },
    onError: () => {
      toast({
        title: 'การบันทึกการตั้งค่าของคุณไม่สำเร็จ',
        description: 'เกิดข้อผิดพลาดระหว่างการบันทึก',
        variant: 'destructive',
      })
    },
  })

  return {
    updatePreference,
    isMutationPending,
    mutationError,
  }
}
